import BackupSettingsModal from './BackupSettingsModal'

export default BackupSettingsModal
